import { Image } from '@starsoft/common/components';
import { ProfileInfoPicureOptionProps } from './props';
import styles from './styles.module.scss';

export function ProfileInfoPicureOption({
  handleSelect,
  option,
  selected,
}: ProfileInfoPicureOptionProps) {
  function handleClick() {
    handleSelect(option);
  }
  return (
    <div
      className={`${styles.container} ${selected ? styles['container--selected'] : ''}`}
      onClick={handleClick}
    >
      <Image
        src={option?.url}
        width={50}
        height={50}
        alt={`avatar-option-${option?.id}`}
        className={styles.container__image}
      />
      {option?.name}
    </div>
  );
}
